/* eslint-disable no-case-declarations */
import { nanoid } from 'nanoid';
import {
  TWITTER_POST_ADD_NEW,
  TWITTER_POST_SET_DATE,
  TWITTER_POINT_TITLE_CHANGE,
  TWITTER_POINT_DESCRIPTION_CHANGE,
  TWITTER_CLEAR_FORM,
  TWITTER_POINT_DELETE,
  TWITTER_POST_TITLE_CHANGE,
  TWITTER_POINTS_HEIGHT,
} from '../../constants/ActionTypes';
import {
  updaterAddNewPost,
  updaterEditTitle,
  updaterEditDescription,
  updaterPointDelete,
} from './updaters';

const twitterPost = (
  state = {
    postTitle: 'Post Title',
    dateFrom: '',
    dateTo: '',
    points: [
      {
        id: nanoid(),
        title: 'Point 1',
        description: 'Point 1 description',
      },
    ],
    pointsHeight: 0,
  },
  action
) => {
  switch (action.type) {
    case TWITTER_POST_ADD_NEW:
      const postsAddNew = updaterAddNewPost(state.points);

      return { ...state, points: postsAddNew };
    case TWITTER_POST_SET_DATE:
      let dateFrom = state.dateFrom;
      let dateTo = state.dateTo;

      if (action.duration === 'from') {
        dateFrom = action.value;
      } else {
        dateTo = action.value;
      }

      return { ...state, dateFrom, dateTo };
    case TWITTER_POINT_TITLE_CHANGE:
      const postsTitleChange = updaterEditTitle(state.points, action);

      return { ...state, points: postsTitleChange };
    case TWITTER_POINT_DESCRIPTION_CHANGE:
      const postsDescriptionChange = updaterEditDescription(
        state.points,
        action
      );

      return { ...state, points: postsDescriptionChange };
    case TWITTER_CLEAR_FORM:
      return {
        ...state,
        postTitle: 'Post Title',
        dateFrom: '',
        dateTo: '',
        points: [
          {
            id: nanoid(),
            title: 'Point 1',
            description: 'Point 1 description',
          },
        ],
      };
    case TWITTER_POINT_DELETE:
      const postsDelete = updaterPointDelete(state.points, action);

      return { ...state, points: postsDelete };
    case TWITTER_POST_TITLE_CHANGE:
      return { ...state, postTitle: action.value };
    case TWITTER_POINTS_HEIGHT:
      return { ...state, pointsHeight: action.value };
    default:
      return state;
  }
};

export default twitterPost;
